export default "__VITE_ASSET__DAp1iCrB__"